import React from 'react';
import styled from 'styled-components';
import { minBreakpointQuery, standardColours } from '../styles';
import { Heading } from './ui';
import FeatureCard from '../components/FeatureCard';

const StyledCategory = styled.section`
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid ${standardColours.grey};

  ${minBreakpointQuery.tiny`
    margin-top: 40px;
    padding-top: 30px;
  `}

  ${minBreakpointQuery.small`
    margin-top: 50px;
    padding-top: 40px;
  `}

  ${minBreakpointQuery.medium`
    margin-top: 60px;
    padding-top: 50px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 70px;
    padding-top: 60px;
  `}

  ${minBreakpointQuery.xxlarge`
    margin-top: 80px;
    padding-top: 70px;
  `}

  &:first-child {
    margin-top: 0;
    padding-top: 0;
    border-top: 0;
  }
`;

const StyledHeader = styled.header`
  display: grid;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;

  ${minBreakpointQuery.small`
    margin-bottom: 40px;
  `}

  ${minBreakpointQuery.smedium`
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  `}

  ${minBreakpointQuery.mlarge`
    grid-template-columns: 1.5fr 1fr;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 50px;
  `}
`;

const StyledText = styled.p``;

const StyledItems = styled.div`
  display: grid;
  gap: 20px;

  ${minBreakpointQuery.small`
    row-gap: 30px;
  `}

  ${minBreakpointQuery.smedium`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${minBreakpointQuery.mlarge`
    grid-template-columns: repeat(3, 1fr);
  `}

  ${minBreakpointQuery.large`
    row-gap: 40px;
  `}
`;

const FeatureCategory = ({ title, description, items }) => (
  <StyledCategory>
    <StyledHeader>
      <Heading>{title}</Heading>
      {description && <StyledText>{description}</StyledText>}
    </StyledHeader>
    <StyledItems>
      {items.map(({ title, slug, description, category }, id) => (
        <FeatureCard
          key={id}
          heading={title}
          slug={slug}
          icon={category.icon}
          text={description}
          category={category}
        />
      ))}
    </StyledItems>
  </StyledCategory>
);

export default FeatureCategory;
